<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left" :style="{ visibility: render ? 'visible' : 'hidden' }">
        <select-cus @change="cusChange"></select-cus>
        <div class="date-picker-v2" :class="{ ml16: cusListTotal.length > 1 }">
          <el-date-picker class="query-date-picker" v-model="wageMonthRange" type="monthrange" format="yyyy-MM"
                          value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" :start-placeholder="$t('from')"
                          :end-placeholder="$t('to')" @change="getData"></el-date-picker>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.idCards" multiple collapse-tags
                     :placeholder="$t('selectStaff')" filterable clearable @change="handleSelectChange"
                     @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.emp" :key="item.id" :value="item.idCard" :label="item.empName"/>
          </el-select>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.costCenters" multiple collapse-tags
                     :placeholder="$t('selectCostCenter')" filterable clearable @change="handleSelectChange"
                     @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.costCenter" :key="item.id" :value="item.costName"
                       :label="item.costName"/>
          </el-select>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.taxTypes" multiple collapse-tags
                     :placeholder="$t('selectTaxType')" filterable clearable @change="handleSelectChange"
                     @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.taxType" :key="item.codeItemId" :value="item.codeItemId"
                       :label="item.codeItemName"/>
          </el-select>
        </div>
        <div v-if="false" class="date-picker-v2">
          <el-date-picker v-model="queryParams.wageMonths" type="months" format="yyyy-MM" value-format="yyyy-MM"
                          :placeholder="$t('salaryMonth')" prefix-icon="none" @change="getData"></el-date-picker>
          <img src="@/assets/img/v2/common/date.png" class="date-picker-icon"/>
        </div>
      </div>
      <div class="title-right title-right-wrap">
        <el-checkbox v-model="radio" @change="changeRadioAction">{{ checkBoxMsg }}</el-checkbox>
        <el-button plain class="button-v2" @click="customHeaderModalShow = true">{{
            $t('displayItemConfiguration')
          }}
        </el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleExport">{{
            $t('export')
          }}
        </el-button>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        v-if="render"
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        :show-operation="false"
        align="center"
        :columns="columns"
        :data="tableData"
        show-footer
        :footer-method="footerMethod"
        @change-filter="changeFilter"
      ></air-table>
      <bsp-pagination :pager-config.sync="queryParams" @page-change="getData" @page-size-change="pageSizeChange"
                      show-page-size></bsp-pagination>
    </div>

    <el-dialog
      class="modal-v2 has-padding"
      width="800px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('displayItemConfiguration')"
      :visible.sync="customHeaderModalShow"
      append-to-body
    >
      <customHeader :header-list.sync="headerList" report-type="员工收入明细表"></customHeader>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="customHeaderModalShow = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="saveCustomHeader">{{
            $t('save')
          }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/v2/stats/emp-income'
import {queryEmpInfoListPage} from '@/api/v2/common'
import exportMethod from '@/util/export'
import customHeader from '@/components/v2/custom-header'
import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
import {updataCustHeaderInfo} from '@/api/wage/pay'
import {mapGetters} from 'vuex';
import {floatSumArray} from '@/util/util';
import {validatenull} from '@/util/validate';
import XEUtils from "xe-utils";

export default {
  name: 'EmpIncomeDetail',
  components: {
    customHeader,
    SelectCus
  },
  data() {
    return {
      hiddenColumns: [],//需要隐藏的列
      expHiddenColumns: [],//需要隐藏的列
      sumListCode: [],//需要合计的列
      radio: false,
      checkBoxMsg: '隐藏空列',
      render: false,
      loading: true,
      wageMonthRange: [],
      isSelectChange: false,
      queryParams: {
        startDate: undefined,
        endDate: undefined,
        idCards: [],
        costCenters: [],
        taxTypes: [],
        // wageMonths: [],
        cuswIds: [],
        isHidden: false,
        page: 1,
        limit: 20,
        total: 0
      },
      limitCustom: 1,
      dictMap: {},
      dictData: {
        emp: [],
        costCenter: [],
        taxType: []
      },
      columns: [],
      tableData: [],
      submitLoading: false,
      customHeaderModalShow: false,
      headerList: []
    }
  },
  computed: {
    ...mapGetters(['cusListTotal'])
  },
  created() {
    const storeParams = this.$getStore('empIncomeDetail_queryParams')
    if (storeParams) {
      // 如果缓存中有参数，则说明是从汇总点击查看明细而来
      this.queryParams = storeParams
      this.$removeStore('empIncomeDetail_queryParams')
    }
    this.init()
  },
  methods: {
    init() {
      this.queryParams.cusId = this.$userInfo.cusId
      this.getEmpList()
      this.getData()
    },
    getData() {
      this.render = false
      this.loading = true
      if (this.$isNotEmpty(this.wageMonthRange)) {
        this.queryParams.startDate = this.wageMonthRange[0]
        this.queryParams.endDate = this.wageMonthRange[1]
      } else {
        this.queryParams.startDate = undefined
        this.queryParams.endDate = undefined
      }
      api.selectDataForSalaryDetail(this.queryParams).then(res => {
        const data = res.data.data
        data.customList.forEach(item => {
          item.minWidth = 140
          if (item.field === 'empName' || item.field === 'identityNum') {
            item.fixed = 'left'
            item.filterType = 'input'
          }
        })
        this.columns = data.customList
        data.translates.forEach(item => {
          if (item.dictMap != undefined) {
            this.dictMap[item.field] = this.$arrayToObj(item.dictMap, 'codeItemId')
          }
        })
        if (!this.dictMap.taxType) {
          this.dictMap.taxType = this.$arrayToObj(data.taxType, 'codeItemId')
        }
        this.tableData = this.$handleTableDict(data.dataList, this.dictMap, '')
        this.queryParams.total = data.params.total
        this.dictData.costCenter = data.costCenter
        this.dictData.taxType = data.taxType
        this.render = true
        this.loading = false
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    getEmpList() {
      queryEmpInfoListPage({cusId: this.$userInfo.cusId, limit: 100000}).then(res => {
        this.dictData.emp = res.data.records
      })
    },
    handleSelectChange(val) {
      if (this.$isEmpty(val)) {
        // 如果val为空数组，则说明触发了清空，此时不会触发visible-change事件，需要手动查询后端
        this.getData()
        this.isSelectChange = false
      } else {
        this.isSelectChange = true
      }
    },
    handleSelectVisibleChange(val) {
      // 多选的blur无法触发，而change事件触发又过于频繁，因此此处使用visible-change，即多选后下拉框消失才会查询后端数据
      if (!val && this.isSelectChange) {
        this.getData()
        // 为了防止查询条件未变化时下拉框消失也查询后端，用此标识来记录select是否有变化，并在此处重置
        this.isSelectChange = false
      }
    },
    saveCustomHeader() {
      if (this.$isEmpty(this.headerList)) {
        this.$msgError('显示项目不能为空')
        return
      }
      let param = {
        headers: this.headerList,
        reportType: '员工收入明细表'
      }
      this.submitLoading = true
      updataCustHeaderInfo(param).then(res => {
        if (res.data.code === 0) {
          this.customHeaderModalShow = false
          this.$msgSuccess('保存成功')
          this.getData()
        }
      }).finally(() => this.submitLoading = false)
    },
    handleExport() {
      let cols = [];
      this.queryParams.isHidden = this.radio;
      if (this.radio && this.expHiddenColumns && this.expHiddenColumns.length > 0) {
        cols = this.$clone(this.expHiddenColumns);
      } else {
        cols = this.$clone(this.columns);
      }
      this.$msgInfo(`${this.$t('startDownloading')}...`);
      exportMethod({
        columns: cols,
        beanName: 'salaryHistoryServiceImpl',
        methodName: 'selectDataForSalaryDetailForExport',
        headerType: '1003',
        headerRowNum: 1,
        isSort: true,
        fileName: "员工收入明细表.xlsx",
        ...this.queryParams,
        type: 'excel'
      }, '/wage', true)
    },
    // 客户筛选change事件
    cusChange({data, checkedLabels, checkedValues}) {
      this.queryParams.cusIds = checkedValues;
      this.getData();
    },
    numToArray(list, field) {
      return list.map(item => {
        return validatenull(item[field]) ? 0 : item[field];
      })
    },
    sumNum(list, field) {
      const numArray = this.numToArray(list, field);
      return floatSumArray(numArray);
    },
    changeRadioAction() {
      if (this.radio) {
        this.hiddenAction();//隐藏
        //this.checkBoxMsg='重置';
      } else {
        this.resetAction();//重置
        //this.checkBoxMsg='隐藏空列';
      }
    },
    //重置
    resetAction() {
      this.hidden = false;
      this.$refs.airTable.$refs.table.resetColumn();
    },
    //隐藏
    hiddenAction() {
      this.expHiddenColumns = []; // 清空
      if (this.hiddenColumns && this.hiddenColumns.length > 0) {
        this.hidden = true;
        // 先收集所有需要隐藏的列对象
        const allCols = [];
        this.columns.forEach(col => {
          // 检查自身field
          if (col.field && !this.hiddenColumns.includes(col.field)) {
            allCols.push(col);
          }
          // 检查分组列
          if (col.grounpColumns && Array.isArray(col.grounpColumns)) {
            const hasChild = col.grounpColumns.some(sub => !this.hiddenColumns.includes(sub.field));
            if (hasChild) {
              allCols.push(col);
            }
          }
        });
        // 去重
        this.expHiddenColumns = [...new Set(allCols)];
        // 然后执行隐藏操作，遍历hiddenColumns
        this.hiddenColumns.forEach(filed => {
          this.$refs.airTable.$refs.table.hideColumn(this.$refs.airTable.$refs.table.getColumnByField(filed));
        });
      }
    },
    footerMethod({columns, data}) {
      let _this = this;
      this.hiddenColumns = [];
      const result = [
        columns.map((column, columnIndex) => {
          if (data && data.length > 0) {
            let columFiled = column.property;
            let result = XEUtils.every(data, (data) => {
              return data[columFiled] === 0 || data[columFiled] === null
                || data[columFiled] === '0' || data[columFiled] === '0.0' || data[columFiled] === '0.00'
            })
            if (result) {
              this.hiddenColumns.push(columFiled)
            }
          }
          if (columnIndex === 0) {
            return '合计';
          } else {
            if (!validatenull(column.params)) {
              const {valueType} = column.params;
              if (valueType == '92420001' || valueType == '92420002') {
                return this.sumNum(data, column.property)
              }
              return null
            } else {
              return null
            }
          }
        })
      ]
      this.$nextTick(() => {
        if (this.radio) {
          this.hiddenAction();
        }
      });
      return result;
    },
    // 输入框回车，调接口
    pageSizeChange(val) {
      this.queryParams = Object.assign(val);
      this.getData();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.app-container-v2.table-container-v2 {
  padding: 24px;
  box-sizing: border-box;
}

.title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 0; /* 重点：垂直间距归零，紧贴下面分割线 */

  .title-left {
    display: flex;
    align-items: center;
    gap: 16px; /* 横向控件统一等距基准，就是你要的“以上面距离为准” */
    flex: 1;
    min-width: 0;
    flex-wrap: wrap;

    .date-picker-v2,
    .select-v2 {
      margin: 0;
    }
  }

  .title-right-wrap {
    flex: 0 0 auto;
    min-width: 240px;
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: flex-end;

    .el-checkbox,
    .button-v2 {
      position: relative;
      z-index: 1;
      white-space: nowrap;
    }
  }
}

.table-body {
  padding: 0;
  .air-table {
    margin-top: 0;
    margin-bottom: 10px;
  }
}
</style>

